import { Injectable, inject } from '@angular/core'
import { Action, Store, select } from '@ngrx/store'

import * as WidgetPagesSelectors from './widget-pages.selectors'

@Injectable({
  providedIn: 'root',
})
export class WidgetPagesFacade {
  private readonly store = inject(Store)

  loaded$ = this.store.pipe(select(WidgetPagesSelectors.selectWidgetPagesLoaded))
  allWidgetPages$ = this.store.pipe(select(WidgetPagesSelectors.selectAllWidgetPages))
  allOldWidgets$ = this.store.pipe(select(WidgetPagesSelectors.selectOldWidgets))
  selectedWidgetPages$ = this.store.pipe(select(WidgetPagesSelectors.selectEntity))
  editCreateWidgetPageLoaded$ = this.store.pipe(select(WidgetPagesSelectors.selectEditCreateWidgetPageLoaded))

  dispatch(action: Action): void {
    this.store.dispatch(action)
  }
}
